import { Injectable } from '@angular/core';
import { LogoutService } from '../services/authentication/logout.service';
import { SoftwareOptionsForCompany } from '@shared/enums';
import { GlobalSettingsService } from '@core/globalSettings.service';
import { CompanyType } from '@nodeModules/@itero/auth-angular';
import { CookieReadWriteService } from '../services/authentication/cookie-read-write.service';

@Injectable()
export class RootGuard {
	constructor(
		private logoutService: LogoutService,
		private globalSettingsService: GlobalSettingsService,
		private cookieService: CookieReadWriteService
	) {}

	canActivate(): boolean {
		const swo = this.globalSettingsService.get().companySoftwareOptions;
		const isLab = (this.cookieService.businessCookie.cookie.companyType as CompanyType) === CompanyType.Lab;

		if (swo.includes(SoftwareOptionsForCompany.cswo_UseMiflPlatform) && isLab) {
			return true;
		}

		return this.logoutService.logoutWithoutSessionInvalidation();
	}
}
